import { render, staticRenderFns } from "./SectionMenuGuide.vue?vue&type=template&id=3874a77a&scoped=true&"
import script from "./SectionMenuGuide.vue?vue&type=script&lang=js&"
export * from "./SectionMenuGuide.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuGuide.vue?vue&type=style&index=0&id=3874a77a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874a77a",
  null
  
)

export default component.exports